module.exports = {"links":{"calendar":"Calendar","login":"Login","reservations":"Reservations","contacts":"Contacts"},"notfound":{"title":"Page not Found"},"no_payment":"Tellimuse eest ei ole tasutud","order_exists":"Tellimust ei leitud","order_no_price":"Tellimusel puudub summa"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 290
// module chunks = 0